<template>
  <span class="archive-term" :class="`ai-${kind}-term`">
    <span :class="`ai-${kind}-term-word`">{{ word }}</span>
    <svg v-if="kind === 'ask' || kind === 'view'" class="archive-term-mark" :class="`ai-${kind}-term-mark`" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 0C9.2 5.1 10.9 6.8 16 8c-5.1 1.2-6.8 2.9-8 8C6.8 10.9 5.1 9.2 0 8 5.1 6.8 6.8 5.1 8 0Z" fill="currentColor"/></svg>
    <GalleryMark v-else-if="kind === 'gallery'" class="archive-term-mark archive-term-gallery"/>
  </span>
</template>

<script>
import GalleryMark from '../view/GalleryMark.vue';
export default {
  name: 'ArchiveTerm',
  components: { GalleryMark },
  props: {
    kind: { type: String, required: true, validator: value => ['search', 'ask', 'view', 'gallery', 'exhibition'].includes(value) },
    plural: { type: Boolean, default: false },
  },
  computed: {
    word() {
      const word = this.kind[0].toUpperCase() + this.kind.slice(1);
      return this.plural && ['view', 'exhibition'].includes(this.kind) ? `${word}s` : word;
    },
  },
};
</script>

<style scoped>
.archive-term { display: inline-flex; align-items: baseline; gap: .08em; white-space: nowrap; color: inherit; font-family: inherit; font-weight: 600; letter-spacing: .012em; }
.archive-term-mark { position: relative; top: -.42em; width: .62em; height: .62em; flex-shrink: 0; color: var(--site-accent); }
.archive-term-gallery { top: -.28em; width: .82em; height: .75em; margin-left: .02em; }
</style>
